import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiRenameUserAccountGroupRequest,
  DefaultApiDeleteUserAccountGroupRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const renameUserAccountGroup = async (
  instance: AxiosInstance,
  params: DefaultApiRenameUserAccountGroupRequest
) => {
  return await userApiDefaultApiFactory(instance).renameUserAccountGroup(params)
}

export const deleteUserAccountGroup = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteUserAccountGroupRequest
) => {
  return await userApiDefaultApiFactory(instance).deleteUserAccountGroup(params)
}

// Do Not Remove this line ===@import api client===
